import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header.jsx';
import Footer from '@/components/Footer.jsx';

function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Términos y Condiciones | Faronexo</title>
        <meta name="description" content="Condiciones de uso del sitio y servicios de Faronexo." />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-background">
        <section className="py-20 bg-muted/30 border-b border-border">
          <div className="max-w-4xl mx-auto container-padding text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Términos y Condiciones
            </h1>
            <p className="text-lg text-muted-foreground">
              Condiciones de uso del sitio y servicios de Faronexo
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="max-w-3xl mx-auto container-padding prose prose-zinc dark:prose-invert prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-6 prose-p:text-muted-foreground prose-p:leading-relaxed prose-li:text-muted-foreground">
            
            <h2>1. Alcance</h2>
            <p>
              Los presentes Términos y Condiciones regulan el acceso y uso del sitio web de <strong>Faronexo</strong>, así como la solicitud y prestación preliminar de nuestros servicios de consultoría en ciberseguridad, auditorías, diagnósticos de riesgo y soluciones relacionadas.
            </p>

            <h2>2. Uso permitido</h2>
            <p>
              El usuario se compromete a hacer un uso legítimo y adecuado de este sitio web y de los servicios ofrecidos. Queda estrictamente prohibido:
            </p>
            <ul>
              <li>El envío de correo no deseado (spam) a través de nuestros formularios.</li>
              <li>La distribución de software malicioso (malware) o cualquier intento de vulnerar la seguridad de este sitio.</li>
              <li>La realización de actividades ilegales, fraudulentas o que atenten contra los derechos de terceros.</li>
            </ul>
            <p>
              El usuario es el único responsable de la veracidad, exactitud y legalidad de la información enviada a través de nuestros formularios de contacto y evaluación.
            </p>

            <h2>3. Evaluaciones y diagnósticos preliminares</h2>
            <p>
              Las evaluaciones rápidas y diagnósticos solicitados a través del sitio web tienen un carácter estrictamente preliminar y orientativo. <strong>No constituyen un diagnóstico final ni exhaustivo</strong> de la postura de seguridad de su empresa. Para obtener resultados concluyentes y recomendaciones definitivas, es necesario contratar un servicio formal que permita un análisis profundo y detallado de su infraestructura. Faronexo no asume responsabilidad por decisiones tomadas basándose únicamente en estas evaluaciones preliminares.
            </p>

            <h2>4. Limitación de responsabilidad</h2>
            <p>
              Faronexo proporciona este sitio web "tal cual" (as is) y no garantiza que el acceso al mismo sea ininterrumpido o libre de errores. Asimismo, Faronexo no será responsable por:
            </p>
            <ul>
              <li>La obtención de resultados específicos no garantizados contractualmente.</li>
              <li>Tiempos de respuesta ante solicitudes que excedan nuestras estimaciones habituales por causas de fuerza mayor.</li>
              <li>Daños o perjuicios derivados de la no implementación de las recomendaciones de seguridad proporcionadas.</li>
              <li>Daños indirectos, lucro cesante o pérdida de datos que el cliente pudiera sufrir.</li>
            </ul>

            <h2>5. Propiedad intelectual</h2>
            <p>
              Todo el contenido de este sitio web, incluyendo pero no limitándose a la marca Faronexo, logotipos, textos, diseños, gráficos y materiales descargables, es propiedad exclusiva de Faronexo o de sus respectivos licenciantes. Queda expresamente prohibida su reproducción, distribución, modificación o uso comercial sin la autorización previa y por escrito de Faronexo.
            </p>

            <h2>6. Modificaciones</h2>
            <p>
              Faronexo se reserva el derecho de modificar, actualizar o suspender en cualquier momento el contenido del sitio web, los servicios ofrecidos y los presentes Términos y Condiciones. Las modificaciones importantes serán notificadas a través de este mismo medio, y su entrada en vigor será inmediata tras su publicación.
            </p>

            <h2>7. Jurisdicción</h2>
            <p>
              Para la resolución de cualquier controversia o conflicto derivado del uso de este sitio web o de la interpretación de estos Términos y Condiciones, las partes se someterán a la legislación aplicable y a los tribunales competentes de la jurisdicción correspondiente a la sede principal de Faronexo.
            </p>

            <h2>8. Contacto</h2>
            <p>
              Para cualquier consulta, reclamo o aclaración relacionada con estos Términos y Condiciones, puede comunicarse con nosotros a través del correo electrónico: <a href="mailto:contactos@faronexo.com" className="text-primary hover:underline">contactos@faronexo.com</a>.
            </p>

            <h2>9. Aceptación</h2>
            <p className="font-medium text-foreground p-4 bg-muted/50 rounded-lg border border-border mt-8">
              El uso de este sitio implica la aceptación de estos Términos y Condiciones.
            </p>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default TermsPage;